import { useQuery } from "@apollo/client";
import { GET_CATEGORY } from "../apollo/queries";
import { getSelectedStoreDetails } from "../utils/helperFunctions";
import useFilters from "../core/hooks/useFilters";

const useCategory = ( parent_id ) => {
  const { search, debouncedValue, onChange, pagination, handlePageChange } =
    useFilters();
  const { loading, error, data, refetch } = useQuery(GET_CATEGORY, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        parent_id: parent_id == undefined ? null : parent_id,
        store_id: getSelectedStoreDetails("id"),
        name: debouncedValue,
        is_active: null,
      },
      getCategoryId: null,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  return {
    values: {
      categoryList: data?.allCategory || [], // Assuming the API returns an items array
      total: data?.allCategory?.total || 0, // Assuming the API returns a total count
      loading,
      search,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allCategory?.total || 0,
      },
    },
    functions: {
      onChange,
      refetch,
      handlePageChange,
    },
  };
};

export default useCategory;
